import { isObject } from "./typeChecks.utils";
export function debounce(fn, options) {
    if (options === void 0) { options = {}; }
    var _a = isObject(options) ? options : { timeout: options }, _b = _a.timeout, timeout = _b === void 0 ? 500 : _b, 
    // @ts-ignore
    _c = _a.scope, 
    // @ts-ignore
    scope = _c === void 0 ? this : _c, fireImmediately = _a.fireImmediately, resetAfter = _a.resetAfter;
    var timer;
    var hasFiredImmediately = false;
    var hasFiredResetTimer;
    var doAfterFireImmediately = function () {
        hasFiredImmediately = true;
        if (resetAfter) {
            hasFiredResetTimer && clearTimeout(hasFiredResetTimer);
            hasFiredResetTimer = setTimeout(function () { return hasFiredImmediately = false; }, resetAfter);
        }
    };
    // @ts-ignore
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var fire = function () { return fn.apply(scope, args); };
        if (fireImmediately && !hasFiredImmediately) {
            if (typeof fireImmediately === 'function') {
                fireImmediately();
            }
            else
                fire();
            doAfterFireImmediately();
        }
        timer && clearTimeout(timer);
        timer = setTimeout(fire, timeout);
    };
}
